"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Col = _interopRequireDefault(require("@concur/nui-layouts/Col"));
var _Row = _interopRequireDefault(require("@concur/nui-layouts/Row"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var routeStateSelector = function routeStateSelector(_ref) {
  var nuiPage = _ref.nuiPage;
  return {
    nuiPage: nuiPage
  };
};

// Ex usage: withSideBar(mySideBar)(MyComponent)
var withSideBar = function withSideBar(SideBar) {
  return function (WrappedComponent) {
    return function (props) {
      var _useSelector = (0, _reactRedux.useSelector)(routeStateSelector),
        _useSelector$nuiPage = _useSelector.nuiPage,
        _useSelector$nuiPage2 = _useSelector$nuiPage === void 0 ? {} : _useSelector$nuiPage,
        is16ColsEnabled = _useSelector$nuiPage2.is16ColsEnabled;
      var convertColSize = function convertColSize(colSize) {
        return is16ColsEnabled ? Math.round(colSize / 3 * 4) : colSize;
      };
      return /*#__PURE__*/_react.default.createElement(_Row.default, null, SideBar && /*#__PURE__*/_react.default.createElement(_Col.default, {
        id: "sidebar1",
        xs: 3,
        sm: convertColSize(3),
        md: convertColSize(3),
        lg: convertColSize(2),
        xl: 2,
        xxl: 2
      }, /*#__PURE__*/_react.default.createElement(SideBar, null)), /*#__PURE__*/_react.default.createElement(_Col.default, {
        id: "nuiContentContainer",
        xs: SideBar ? 9 : 12,
        sm: SideBar ? convertColSize(9) : convertColSize(12),
        md: SideBar ? convertColSize(9) : convertColSize(12),
        lg: SideBar ? convertColSize(10) : convertColSize(12),
        xl: SideBar ? 14 : 16,
        xxl: SideBar ? 14 : 16
      }, /*#__PURE__*/_react.default.createElement(WrappedComponent, props)));
    };
  };
};
var _default = exports.default = withSideBar;